import React, {useState} from 'react';
import {logout} from "../services/authService";
import {Crown, Edit, Eye, Send, UserCheck, UserX} from 'lucide-react';
import {Outlet, useNavigate} from "react-router-dom";
import {useAuth} from "../contexts/AuthContext";
import DashboardIcon from '@rsuite/icons/legacy/Dashboard';
import OperatePeopleIcon from '@rsuite/icons/OperatePeople';
import PeoplesMapIcon from '@rsuite/icons/PeoplesMap';
import ArchiveIcon from '@rsuite/icons/Archive';
import InfoOutlineIcon from '@rsuite/icons/InfoOutline';
import GridIcon from '@rsuite/icons/Grid';
import "./styles/Avatar.css"
import AdvancedAnalyticsIcon from '@rsuite/icons/AdvancedAnalytics';
import {
    DeliveredProcedureOutlined,
    DownloadOutlined,
    LogoutOutlined,
    SafetyOutlined,
    UserOutlined
} from "@ant-design/icons";
import {Avatar, Button, Card, Dropdown, Layout, Menu, Space, Tooltip, Typography} from "antd";
import {useTheme} from "../contexts/ThemeContext"
import ThemeSwitcher from "./ux_ui/ThemeSwitcher";
import {useStore} from "../contexts/AppContext";
import TgConnect from "./TgConnect";

const {Sider} = Layout;
const {Text} = Typography;


const accountSettings = [
    {
        key: 'tg_account',
        label: 'Connect telegram',
        icon: <Send size={12}/>,
        modal: {
            title: 'Telegram',
            content: 'telegram',
        },
    },
];

const items = [
    {
        key: '/dashboard/all-documents',
        label: 'All documents',
        icon: <DashboardIcon/>,
    },
    {
        key: '2',
        label: 'I manage',
        icon: <OperatePeopleIcon/>,
        children: [
            {key: '/dashboard/i-manage-responsible', label: 'I\'m responsible', icon: <Crown size={15}/>},
            {key: '/dashboard/i-manage-assigned', label: 'I\'m assigned', icon: <UserCheck size={15}/>},
            {key: '/dashboard/i-manage-assigned-others', label: 'I assigned others', icon: <UserX size={15}/>},
        ],
    },
    {
        key: '3',
        label: 'By role',
        icon: <PeoplesMapIcon/>,
        children: [
            {key: '/dashboard/role-owner', label: 'Owner', icon: <Crown size={15}/>},
            {key: '/dashboard/role-responsible', label: 'Responsible', icon: <UserCheck size={15}/>},
            {key: '/dashboard/role-editor', label: 'Editor', icon: <Edit size={15}/>},
            {key: '/dashboard/role-viewer', label: 'Viewer', icon: <Eye size={15}/>},
        ],
    },
    {
        key: "/dashboard/archive",
        label: 'Archive',
        icon: <ArchiveIcon/>,
    },
    {
        key: "5",
        label: 'Access requests',
        icon: <SafetyOutlined/>,
        children: [
            {key: '/dashboard/access-requests-to-me', label: 'To me', icon: <DownloadOutlined/>},
            {key: '/dashboard/access-requests-from-me', label: 'From me', icon: <DeliveredProcedureOutlined/>},
        ],
    },
    {
        key: "/dashboard/faq",
        label: 'FAQ',
        icon: <InfoOutlineIcon/>,

    },
    {
        key: '7',
        label: 'Other Services',
        icon: <GridIcon/>,
        children: [
            {key: '/dashboard/onboarding', label: 'Onboarding', icon: <AdvancedAnalyticsIcon/>},
        ],
    },
];


const SideBar = () => {
    const navigate = useNavigate();
    const {userInfo} = useAuth();
    const [current, setCurrent] = useState('/dashboard/all-documents');
    const {selectedTheme} = useTheme()
    const {setRequestAccessData} = useStore()


    const redirectToPage = async (e) => {
        const key = e.key
        if (key === 'tg_account') {
            navigate('tg/registration')
        }
    };


    const handleLogout = async () => {
        window.location.href = await logout();
    };


    const onClick = e => {
        setCurrent(e.key);
        navigate(e.key)
        setRequestAccessData((prevPage => ({
            ...prevPage,
            access_form: false,
            access_accept_access_mode: 'request',
        })))
    };

    if (!userInfo.telegramId) return (
        <Layout style={{minHeight: "100vh", gap: 10, backgroundColor: selectedTheme}}>
            <TgConnect/>
        </Layout>
    )


    return (
        <Layout style={{minHeight: "100vh", gap: 10, backgroundColor: selectedTheme}}>
            <Sider
                width={256}
                style={{height: "100%"}}
            >
                <Card
                    style={{
                        position: "relative",
                        textAlign: "center",
                        borderRadius: 0,
                    }}
                    variant="borderless"
                >
                    <div style={{position: "absolute", top: 10, right: 10}}>
                        <ThemeSwitcher/>
                        <Tooltip title="Logout" placement="right">
                            <Button
                                style={{marginTop: 50}}
                                type="text"
                                icon={<LogoutOutlined/>}
                                onClick={handleLogout}
                                danger
                            />
                        </Tooltip>
                    </div>

                    <div style={{width: "100%"}}>
                        <Tooltip placement="left">
                            <Dropdown
                                menu={{
                                    items: accountSettings,
                                    onClick: redirectToPage,
                                }}
                                placement="bottom"
                                trigger={['click']}
                            >
                                <Space
                                    direction="vertical"
                                    align="center"
                                    style={{cursor: "pointer"}}
                                >
                                    <div className="avatar-wrapper">
                                        <Avatar
                                            size={50}
                                            src={userInfo?.avatar || "https://api.dicebear.com/7.x/miniavs/svg?seed=1"}
                                            icon={!userInfo?.avatar && <UserOutlined/>}
                                            style={{backgroundColor: "#7265e6"}}
                                        />
                                    </div>
                                    <Text strong>
                                        {userInfo?.first_name} {userInfo?.last_name}
                                    </Text>
                                </Space>
                            </Dropdown>
                        </Tooltip>
                    </div>
                </Card>

                <Menu
                    onClick={onClick}
                    style={{flex: 1, borderRight: 0}}
                    defaultOpenKeys={["2", "3", "5", "7"]}
                    selectedKeys={[current]}
                    mode="inline"
                    items={items}
                />
            </Sider>
            <Outlet/>
        </Layout>

    );
};

export default SideBar;
